function trackPageView (path) {
  if (!path) {
    return
  }
  // 定制#异步模式
  if (!path.startsWith('#')) {
    path = '#' + path
  }
  let pathname = window.location.pathname
  if (path.indexOf(pathname) < 0) {
    path = pathname + path
  }
  console.log('trackPageView ', path)
  if (typeof window._hmt !== 'undefined') {
    window._hmt.push(['_trackPageview', path])
  }
}

function trackEvent (category, action, optLabel, optValue) {
  if (!category || !action) {
    return
  }
  console.log(' trackEvent ', category, action, optLabel, optValue)
  if (typeof window._hmt !== 'undefined') {
    window._hmt.push(['_trackEvent', category, action, optLabel, optValue])
  }
}

export {
  trackEvent,
  trackPageView
}

export default {
  trackEvent,
  trackPageView
}



// WEBPACK FOOTER //
// ./src/libs/utils/baidu.js